<template>
  <div class="mb-sm-5">
    <v-divider v-if="dividerBefore" class="mb-sm-5"/>
    <div class="entity-dialog-input-row d-flex flex-wrap mb-4"
         :class="$vuetify.breakpoint.name">
      <label v-if="label"
             :for="forId"
             class="input-label pt-3 pb-1 pb-sm-2"
             :req="''+ required">{{ label }}</label>
      <div v-if="!label" class="no-label"></div>
      <div class="flex-grow-1">
        <slot></slot>
      </div>
    </div>
    <v-divider v-if="dividerAfter"/>
  </div>
</template>
<style scoped>
.entity-dialog-input-row {
  flex-flow: row;
}

.xs.entity-dialog-input-row {
  flex-flow: column;
}

.entity-dialog-input-row .input-label[req=true]:after {
  content: " *";
  color: red;
}

.entity-dialog-input-row .input-label {
  width: 12em;
  font-weight: bolder;
  margin-right: 1em;
}

.entity-dialog-input-row .no-label {
  width: 12em;
  height: 0;
  margin-right: 1em;
}

.xs.entity-dialog-input-row .input-label {
  width: auto;
}

</style>
<script>
export default {
  name: 'EntityDialogInputRow',
  props: {
    label: {
      type: String,
      required: false,
    },
    forId: {
      //id of the input element
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },

    dividerBefore: {
      type: Boolean,
      default: false,
    },

    dividerAfter: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

